var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.subscription
    ? _c("ModalFullScreen", {
        attrs: { title: "Welcome to ProveraCare!" },
        on: {
          close: function ($event) {
            return _vm.$emit("close")
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "form",
              fn: function () {
                return [
                  _c("div", { staticClass: "text-sm" }),
                  _c("p", { staticClass: "mb-1" }, [
                    _vm._v(
                      " To get you started, you were automatically subscribed to the " +
                        _vm._s(_vm.details.subscriptionPlanName) +
                        " for free for the next 30 days. No credit card is required. "
                    ),
                  ]),
                  _c(
                    "p",
                    { staticClass: "mb-5" },
                    [
                      _vm._v(
                        " This plan has up to " +
                          _vm._s(_vm.details.managersCount) +
                          " manager seats, but if you need any more, you can change it any time on the "
                      ),
                      _c(
                        "RouterLink",
                        {
                          staticClass: "font-bold text-primary",
                          attrs: { to: _vm.pricingRoute },
                        },
                        [_vm._v(" Pricing management page. ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "actions",
              fn: function () {
                return [
                  _c("ModalSectionsDivider"),
                  _c(
                    "div",
                    { staticClass: "flex pt-5" },
                    [
                      _c("UiButton", {
                        staticClass: "mr-4",
                        attrs: { buttonText: "Cancel", variant: "outline" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("close")
                          },
                        },
                      }),
                      _c("UiButton", {
                        attrs: { buttonText: "Manage subscriptions" },
                        on: { click: _vm.openPricingPage },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          627291929
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }